import React, { useCallback, useMemo } from 'react';
import {
  ChatStates,
  isIteratingBranchingNodesSelector,
  selectChatState,
  selectChatStatus,
  setUserEndPromptActive,
  virtualHumanTalkingSelector,
} from '../../../slices/chat/ChatSlice';
import IconLabelButton, {
  IconLabelButtonTypes,
} from '../IconLabelButton/IconLabelButton';
import { useDispatch, useSelector } from 'react-redux';
import { useVHTypeConfig } from '../../vh-types/vhTypeHooks';
import { patientSelector } from '../../../slices/PatientSlice';
import { useTranslation } from 'react-i18next';

const CompleteSessionButton = (props) => {
  const dispatch = useDispatch();
  const chatState = useSelector(selectChatState);
  const vhTypeConfig = useVHTypeConfig();
  const vhDBVH = useSelector(patientSelector);
  const chatStatus = useSelector(selectChatStatus);
  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);
  const isIteratingBranchingNodes = useSelector(
    isIteratingBranchingNodesSelector
  );
  const handleOpen = useCallback(() => {
    dispatch(setUserEndPromptActive(true));
  }, [dispatch]);

  const finishButtonText = useMemo(
    () => vhTypeConfig.finishButtonText(vhDBVH),
    [vhDBVH, vhTypeConfig]
  );

  const { t } = useTranslation();

  return (
    <IconLabelButton
      type={IconLabelButtonTypes.BLUE}
      disabled={
        chatState !== ChatStates.TALK ||
        virtualHumanTalking ||
        chatStatus !== 'idle' ||
        isIteratingBranchingNodes
      }
      onClick={handleOpen}
    >
      {t(finishButtonText)}
    </IconLabelButton>
  );
};

CompleteSessionButton.propTypes = {};

export default CompleteSessionButton;
